import Image from 'next/image';
import Link from 'next/link';
import cn from 'classnames';
import { getEdgeUrl } from '@/lib/getEdgeUrl';
import { VisionSectionProps } from './types';
import i18n from '@/settings/i18n';

const t = i18n.init('about');

const Section = ({ children, className }: VisionSectionProps) => (
  <div
    className={cn(
      'relative flex h-full min-h-[200px] w-full items-center justify-center px-5 py-8 sm:p-8 lg:h-[300px]',
      className,
    )}
  >
    {children}
  </div>
);

const Vision = () => (
  <section className="grid grid-cols-1 xxs:grid-cols-2">
    <Section className="bg-white">
      <div className="w-full max-w-[375px]">
        <p className="lg:text-base">
          {t`Inspiring change, in & around us - that's the vision behind Reebelo. We pledge to reduce unnecessary waste by making certified refurbished & preloved products a #1 choice.`}
        </p>
        <Link
          href="/collections/hot-deals"
          className="mt-5 flex h-9 w-fit items-center justify-center rounded-md border-[1.5px] border-gray-700 px-5 text-xs font-semibold transition duration-150 ease-in-out hover:bg-gray-700 hover:text-white md:text-sm lg:h-10"
        >
          {t`Shop our deals`}
        </Link>
      </div>
    </Section>
    <Section className="bg-gray-700">
      <>
        <div className="relative z-10 mx-auto w-full max-w-[350px] text-white xs:max-w-[300px]">
          <p className="text-lg font-bold leading-snug md:text-xl">
            {t`We believe quality tech & lifestyle essentials empower us. They should be sustainable for`}{' '}
            <span className="text-teal-500">
              {t`the planet and accessible to all.`}
            </span>
          </p>
        </div>
        <div className="absolute left-0 top-0 z-0 h-full w-full">
          <Image
            alt="Background"
            src={getEdgeUrl('images/about-us/vision/background.png')}
            height={1000}
            width={1000}
            className="h-full w-full object-cover"
            quality={100}
          />
        </div>
      </>
    </Section>
  </section>
);

export default Vision;
